// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IUserBookPurchaseItem,
}                               from '../interfaces';

const getUserBookPurchases = async ({
    test,
}: {
    test: boolean,
}): Promise<IUserBookPurchaseItem> => {
    const functions = getFunctions();
    const handleGetUserBookPurchases = httpsCallable<
        Record<
            string,
            boolean
        >,
        IUserBookPurchaseItem
    >(
        functions,
        'getUserBookPurchases',
    );
    return handleGetUserBookPurchases({
        test,
    }).then((result) => {
        const bookPurchases = result.data as IUserBookPurchaseItem;
        return bookPurchases;
    }).catch((err) => {
        throw err;
    });
};

export default getUserBookPurchases;
